import axios from 'axios';

export const moneybirdService = {
  async getStatus() {
    const response = await axios.get('/integrations/moneybird/status');
    return response.data;
  },

  async connect(payload) {
    const response = await axios.post('/integrations/moneybird/connect', payload);
    return response.data;
  },

  async update(payload) {
    const response = await axios.patch('/integrations/moneybird', payload);
    return response.data;
  },

  async disconnect() {
    const response = await axios.delete('/integrations/moneybird');
    return response.data;
  },

  async listTaxRates() {
    const response = await axios.get('/integrations/moneybird/tax-rates');
    return response.data;
  },

  async listLedgerAccounts() {
    const response = await axios.get('/integrations/moneybird/ledger-accounts');
    return response.data;
  },

  async registerWebhook() {
    const response = await axios.post('/integrations/moneybird/webhook');
    return response.data;
  },

  async syncInvoice(invoiceId) {
    const response = await axios.post(`/integrations/moneybird/invoices/${invoiceId}/sync`);
    return response.data;
  },
};

export default moneybirdService;
